module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/subcategories/cleaning-24a5f9074a94d57f37403a2609626eb9.png";